import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 5,
  selectedBranch: "",
};
const filterUnitSlice = createSlice({
  name: "filterItemUnit",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload;
    },
    resetAll: (state) => {
      state.page = 1;
      state.limit = 5;
    },
  },
});
export const { setPage, setLimit, resetAll, setSelectedBranch } =
  filterUnitSlice.actions;
export default filterUnitSlice.reducer;
